<template>
    <div class="circular-chart">
        <svg viewBox="0 0 36 36">
            <path class="circle grey" strokedasharray="100, 100"
                  d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831" />
            <path class="circle"
                  :stroke-dasharray="buildStroke()"
                  :stroke="buildColor()"
                  d="M18 2.0845
      a 15.9155 15.9155 0 0 1 0 31.831
      a 15.9155 15.9155 0 0 1 0 -31.831" />
            <circle :cx="buildHelperPosition().x" :cy="buildHelperPosition().y" r="2" stroke="white" stroke-width="0.5" fill="black" />
        </svg>
        <div v-bind:style="{ color: buildColor() }">
            <span v-if="percentage <= 99.93" class="percentage">{{parseInt(percentage)}}&nbsp;%</span>
            <i v-else class="fas fa-check"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProgressGraph'
        , props: {
            percentage: Number,
            colorCode: String
        },
        methods: {
            buildHelperPosition() {
                var centerx = 18;
                var centery = 18;
                var circleRadius= 15.9155;

                var positionDegree = ((360.0 * (this.percentage || 0)) / 100) - 90;
                var positionRad = positionDegree * Math.PI / 180;

                var bulletx = centerx + Math.cos(positionRad) * circleRadius;
                var bullety = centery + Math.sin(positionRad) * circleRadius;
                return { x: bulletx, y: bullety };

            },
            buildStroke() {
                return (this.percentage || 0) + ", 100";
            },
            buildColor() {
                if (!this.colorCode) return "rgba(0,0,0,0.5)";
                if (this.colorCode.indexOf("#") == -1) return "#" + this.colorCode;
                return (this.colorCode);
            }
        }
    }
</script>

<style scoped>
    .circular-chart {
        display: inline-block;
        width: 40px;
        height: 40px;
        position: relative;
        display: flex;
    }

        .circular-chart > svg {
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
        }

        .circular-chart > div {
            align-self: center;
            text-align: center;
            width: 100%;
            font-weight: 600;
            font-size:11px;
        }

    .circle {
        fill: none;
        stroke-width: 2px;
        stroke-linecap: round;
    }

        .circle.grey {
            stroke: rgba(0,0,0,0.1);
            stroke-width: 2px;
        }
    span.percentage {
        color:black;
    }
</style>